import {
  constructList,
  getFacet,
  getText,
  sortAndSliceList,
  appendGOATandCountryCodeToTitle,
  stripSpecialCharacterFromString,
} from 'shared/utils/pageMetadataUtils';
import { startCase } from 'shared/utils/startCase';
import { t } from 'localization/utils/t';

const TP = 'shared.utils.getTechnologyValuedata';

export const getTechnologyValueMetadata = ({
  pageTitle,
  pageDescription,
  constructorResponse,
  locale,
  query,
}) => {
  const { groups = [], facets = [] } = constructorResponse?.response || {};
  const technologyValue: string = stripSpecialCharacterFromString(query?.technologyValue);
  const technologyValueWithStartCase: string = startCase(technologyValue);
  const topLevelCategory: string =
    groups?.[0]?.group_id === 'sneakers'
      ? t(`${TP}.shoes`, 'shoes')
      : stripSpecialCharacterFromString(groups?.[0]?.group_id);
  const topLevelCategoryWithStartCase: string = startCase(topLevelCategory);

  const brandFacet = getFacet(facets, 'brand');

  const topThreeBrands = constructList({
    list: sortAndSliceList(brandFacet?.options),
    key: 'display_name',
  });

  // Pulling out static strings for translation purposes
  const formattedTopThreeBrands = getText('', topThreeBrands?.constructedList);
  const newReleasesAndIconicStylesFromTopThreeBrands =
    formattedTopThreeBrands?.length > 0
      ? t(
          `${TP}.newReleasesAndIconicStylesFromTopThreeBrands`,
          'New releases & iconic styles from {formattedTopThreeBrands}.',
          { formattedTopThreeBrands },
        )
      : '';

  const title = t(
    `${TP}.title`,
    'Buy {topLevelCategoryWithStartCase} featuring {technologyValueWithStartCase} technology',
    {
      topLevelCategoryWithStartCase,
      technologyValueWithStartCase,
    },
  );

  const description = t(
    `${TP}.description`,
    'Shop {topLevelCategory} featuring {technologyValue} technology on GOAT. {newReleasesAndIconicStylesFromTopThreeBrands} Authenticity assured.',
    {
      topLevelCategory,
      technologyValue,
      newReleasesAndIconicStylesFromTopThreeBrands,
    },
  );

  return {
    pageTitle: pageTitle || appendGOATandCountryCodeToTitle(startCase(title), locale),
    pageDescription: pageDescription || description,
  };
};
